module.exports = __webpack_public_path__ + "img/loginPic.96c0e04c.png";